// Extras advertised on the start screen, in display order. Title, copy and
// price live under `extras.<key>` in both i18n message files.
//
// `icon` is a Material Symbols name — a new name also has to go into the
// subsetted icon font, see the comment at the top of src/assets/base.css.
export const extras = [
    {key: 'lateCheckout', icon: 'schedule'},
]
